"use client";

import { usePathname } from "next/navigation";

import { getLanguageFromPathname } from "@/lib/i18n/paths";
import { createTranslator } from "@/lib/i18n/translations";

import { MovieStatusMessage } from "./MovieStatusMessage";

/** 404 UI for unknown movies (not-found.tsx files receive no params). */
export function MovieNotFound() {
  const lang = getLanguageFromPathname(usePathname());
  const t = createTranslator(lang);

  return (
    <MovieStatusMessage
      description={t("movieDetail.notFoundDescription")}
      icon="🎬"
      link={{
        href: `/${lang}/movies`,
        label: t("movieDetail.browseAllMovies"),
      }}
      title={t("movieDetail.notFoundTitle")}
    />
  );
}
